import { tsv } from "@faire/slate/lib/tsv";
import React from "react";

type IProps = React.ProgressHTMLAttributes<HTMLProgressElement> & {
  /**
   * The progress value (0-100)
   */
  value: number;
  /**
   * The maximum value
   * @default 100
   */
  max?: number;
};

export const ProgressBarBar: React.FC<IProps> = ({
  value,
  max = 100,
  className,
  ...props
}) => {
  const containerCls = containerStyle.cls({ className });
  const containerVars = containerStyle.vars({
    value: `${Math.min(Math.max(value, 0), 100)}%`,
  });

  return (
    <div className={containerCls} style={containerVars}>
      <progress className="sr-only" value={value} max={max} {...props} />
    </div>
  );
};

const containerStyle = tsv({
  vars: {
    value: "fs-progress-bar-value",
  },
  base: "fs-progress-bar__bar",
});
